import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { DocMetaResponse } from '@qtek/shared/models';
import { filter, pipe, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { TermSheetDocMetaService } from './term-sheet-doc-meta.service';

export interface TermSheetConnectPayload {
  mysid: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  q: any[];
}

export interface TermSheetState {
  docMeta: Record<string, DocMetaResponse>;
}

const initialState: TermSheetState = {
  docMeta: {},
};

export const TermSheetStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, service = inject(TermSheetDocMetaService)) => {
    const disconnect$ = new Subject<string>();

    return {
      connect: rxMethod<TermSheetConnectPayload>(
        pipe(
          switchMap(({ mysid, q }) =>
            service.subscribeDocMeta({ mysid, q, s: 'model' }).pipe(
              takeUntil(disconnect$.pipe(filter(id => id === mysid))),
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              tap(({ op, res }: any) => {
                if ((op !== 'query' && op !== 'ins') || !res) {
                  return;
                }
                patchState(store, state => ({
                  docMeta: { ...state.docMeta, [mysid]: res },
                }));
              })
            )
          )
        )
      ),

      disconnect(mysid: string): void {
        disconnect$.next(mysid);
        patchState(store, state => {
          const { [mysid]: _, ...docMeta } = state.docMeta;
          return { docMeta };
        });
      },
    };
  })
);
